// extracted by mini-css-extract-plugin
export var game__card = "index-module--game__card--cae3f";
export var game__description = "index-module--game__description--292ee";
export var game__link = "index-module--game__link--57e75";
export var game__name = "index-module--game__name--7478d";
export var game__wrapper = "index-module--game__wrapper--b9a88";